var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.582 261.19h-19.164a2.41 2.41 0 0 0 -2.418 2.401v19.2a2.41 2.41 0 0 0 2.418 2.4h19.164a2.41 2.41 0 0 0 2.418-2.401v-19.2a2.41 2.41 0 0 0 -2.418-2.4m-13.882 18.99h-3.23v-10.266h3.23zm-1.636-11.527a1.6 1.6 0 1 1 .042-3.189 1.6 1.6 0 1 1 -.042 3.189m13.427 11.527h-3.23v-5.689c0-1.324-.467-2.226-1.637-2.226a1.77 1.77 0 0 0 -1.655 1.2 2.3 2.3 0 0 0 -.106.8v5.921h-3.231v-6.991c0-1.28-.041-2.351-.083-3.275h2.8l.151 1.426h.061a3.748 3.748 0 0 1 3.208-1.658c2.125 0 3.719 1.407 3.719 4.431z",
    fill: "#fff",
    transform: "translate(0 -261.19)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.15600bb32a73e812c7de9fa97a66f2db.svg";
export { ForwardRef as ReactComponent };